/**
 * @author      yontaek@zumper.com (Yon Taek Chung)
 * @copyright   Copyright (c) 2023, Zumper
 */

import type { AnalyticsC, Origin } from '@zcode/nr-utils'
import type { Listable, Pin, RawPinInventorySearch } from '@zcode/state-type'
import React, { type ForwardedRef, forwardRef } from 'react'
import { MessageButtonListCardContainer } from '../../../../../MessageButton/MessageButtonListCardContainer'
import css from './ListingCardMessageButton.module.scss'

type ListingCardMessageButtonProps = React.RefAttributes<HTMLAnchorElement & HTMLButtonElement> & {
  analyticChannel:
    | typeof AnalyticsC.FULL_DETAIL
    | typeof AnalyticsC.LIST
    | typeof AnalyticsC.LIST_ITEM
    | typeof AnalyticsC.LIST_ITEM_MESSAGED
    | typeof AnalyticsC.PERMANENT_ADDRESS
    | typeof AnalyticsC.PROGRAMMATIC_RENT
    | typeof AnalyticsC.HOMEPAGE
    | typeof AnalyticsC.AFFORDABILITY_CALCULATOR
  dataTestId?: string
  entity: Listable | Pin<RawPinInventorySearch>
  origin: Origin
  extraPayload?: { currentTab?: string }
  isSpotlightVariation?: boolean
}

export const ListingCardMessageButton = forwardRef(
  (
    props: ListingCardMessageButtonProps,
    ref: ForwardedRef<HTMLAnchorElement & HTMLButtonElement>
  ) => {
    const { entity, isSpotlightVariation } = props

    if (!entity.isActive && entity.waitlistEnabled) {
      return null
    }
    return (
      <MessageButtonListCardContainer
        equalCTAIntent={entity.waitlistEnabled ? 'Waitlist' : undefined}
        isSpotlightVariation={isSpotlightVariation}
        ref={ref}
        text={entity.waitlistEnabled ? 'Ask to join waitlist' : 'Check availability'}
        variant={isSpotlightVariation ? 'ghost' : 'solid'}
        buttonCustomStyle={isSpotlightVariation ? css.messageButtonSpotlight : css.messageButton}
        {...props}
      />
    )
  }
)
